import { render } from "./A11y.vue?vue&type=template&id=39194e66"
import script from "./A11y.vue?vue&type=script&lang=js"
export * from "./A11y.vue?vue&type=script&lang=js"
script.render = render

export default script